/**
 * Google Analytics 4 跟踪工具
 * 域名已配置为ejtnewenergy.com
 */

// 您的GA4测量ID，需要从Google Analytics控制台中获取
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX';

/**
 * 初始化GA4
 * 在Gatsby浏览器API文件中调用
 */
export const initGA = () => {
  if (typeof window === 'undefined') return;
  
  // 避免开发环境初始化
  if (process.env.NODE_ENV === 'development') {
    console.log('Google Analytics 在开发环境中被跳过');
    return;
  }
  
  // 避免重复初始化
  if (window.gtag) return;
  
  // 添加GA4脚本
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  
  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_MEASUREMENT_ID}', {
      page_path: window.location.pathname,
    });
  `;
  
  document.head.appendChild(script1);
  document.head.appendChild(script2);
};

/**
 * 发送页面浏览事件
 * 用于SPA页面切换时
 * @param {string} pagePath 页面路径
 */
export const pageview = (pagePath) => {
  if (!window.gtag) return;
  
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: pagePath,
  });
};

/**
 * 发送自定义事件
 * @param {string} eventName 事件名称
 * @param {Object} params 事件参数
 */
export const event = (eventName, params = {}) => {
  if (!window.gtag) return;
  
  window.gtag('event', eventName, params);
};

// 电子商务事件示例
export const ecommerceEvents = {
  // 查看产品
  viewItem: (product) => {
    event('view_item', {
      currency: 'USD',
      value: product.price,
      items: [{
        item_id: product.id,
        item_name: product.name,
        price: product.price,
      }]
    });
  },
  
  // 更多电子商务事件可以根据需要添加
};

// 创建导出对象
const analyticsModule = {
  initGA,
  pageview,
  event,
  ecommerceEvents
};

export default analyticsModule; 